import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { DealershipSendSmsComponent } from './dealership.send-sms.component';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    DealershipSendSmsComponent
  ],
  entryComponents: [
    DealershipSendSmsComponent
  ],
  imports: [
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class DealershipModule {}
